import gql from 'graphql-tag';

export default gql`
  fragment caseStudyFragment on CaseStudy {
    id
    siteName
  }
`;
